import GlobalToolsIcon from "@/assets/globaltools.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const GlobalToolsLogo = (props: Props) => (
  <LogoImage imgSrc={GlobalToolsIcon} alt="Global Tools Logo" size="navbar" {...props} />
);
